import { useMutation } from '@tanstack/react-query';
import type { CustomStatus } from 'src/@types/user-status';
import { queryClient } from 'src/utils/react-query';
import {
  type WorkspaceInfoQueryData,
  workspaceQueryKey,
} from '../providers/WorkspaceInfo/hooks/common';

export function useUpdateUserCustomStatusMutation() {
  const { mutateAsync: updateUserCustomStatus } = useMutation(
    async (payload: { userId: string; customStatus: CustomStatus }) => payload,
    {
      onSuccess(payload) {
        const { userId, customStatus } = payload;
        queryClient.setQueryData<WorkspaceInfoQueryData>(
          workspaceQueryKey,
          (currentWorkspaceInfo) => {
            return {
              ...(currentWorkspaceInfo as WorkspaceInfoQueryData),
              workspace: {
                ...(currentWorkspaceInfo?.workspace as WorkspaceInfoQueryData['workspace']),
                users:
                  currentWorkspaceInfo?.workspace?.users?.map((user) =>
                    user._id === userId
                      ? {
                          ...user,
                          customStatus,
                          lastAccess: new Date().toISOString(),
                        }
                      : user,
                  ) || [],
              },
            };
          },
        );
      },
    },
  );

  return {
    updateUserCustomStatus,
  };
}
